import { render, staticRenderFns } from "./CCSMockUp.vue?vue&type=template&id=47319e2c&"
import script from "./CCSMockUp.vue?vue&type=script&lang=js&"
export * from "./CCSMockUp.vue?vue&type=script&lang=js&"
import style0 from "./CCSMockUp.vue?vue&type=style&index=0&id=47319e2c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports